export const HAIR_COLOR_APPLY_TITLE = 'Applying your shade';

export const HAIR_APPLY_DONE = 'Your look is ready';

export const HAIR_COLOR_PHASE_MESSAGES = {
  prepare: 'Opening your photo…',
  queue: 'Starting your colour session…',
  mask: 'Placing colour in the right section…',
  render: 'Refreshing your hair shade…',
  blend: 'Softening the blend along each strand…',
  finish: 'Polishing the final finish…',
};

export function hairColorApplyMessageForProgress(progress) {
  const p = Math.max(0, Math.min(100, Math.round(Number(progress) || 0)));
  if (p >= 100) return HAIR_APPLY_DONE;
  if (p >= 90) return HAIR_COLOR_PHASE_MESSAGES.finish;
  if (p >= 72) return HAIR_COLOR_PHASE_MESSAGES.blend;
  if (p >= 54) return HAIR_COLOR_PHASE_MESSAGES.render;
  if (p >= 38) return HAIR_COLOR_PHASE_MESSAGES.mask;
  if (p >= 18) return HAIR_COLOR_PHASE_MESSAGES.queue;
  return HAIR_COLOR_PHASE_MESSAGES.prepare;
}

export function hairJobProgressFloor(status) {
  const s = String(status || '').trim().toLowerCase();
  if (s === 'queued') return 14;
  if (s === 'waiting_for_gpu') return 26;
  if (s === 'loading_model') return 38;
  if (s === 'processing') return 52;
  if (s === 'enhancing') return 78;
  if (s === 'uploading') return 88;
  if (s === 'completed') return 100;
  return 10;
}

export function setHairColorApplyLoaderStep(setProgress, setMessage, progress) {
  const p = Math.max(0, Math.min(100, Math.round(progress)));
  setProgress(p);
  setMessage(hairColorApplyMessageForProgress(p));
}
